<template>
    <!--订单详情页-->
    <div class="container">
        <remote-script src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-script>
        <div class="chooseAdr clearfix">
            <div class="adrbtn fl">
                <em class="iconfont icon-weizhi1"></em>
            </div>
            <div class="adrMidd fl">
                <div class="clearfix">
                    <p class="fl">收件人:<span v-text="addressee"></span></p>
                    <p class="fr" v-text="phone"></p>
                </div>
                <p class="adrdel twoEllipsis" v-text="address"></p>
            </div>
        </div>
        <div class="lineBg"><img src="../assets/line.png"/></div>
        <!--商品信息-->
        <div class="shopdelBox clearfix boxSizing">
            <div class="shopimg fl"><img :src="bookCover"/></div>
            <div class="shopMsg">
                <p class="shopName twoEllipsis" v-text="booktit"></p>
                <div class="clearfix shopNP">
                    <p class="shopPrice fl">￥<span v-text="bookPrice"></span></p>
                    <p class="shopNum fr">数量：x<span v-text="currNum"></span></p>
                </div>
            </div>
        </div>
        <!--编辑数量-->
        <div class="editNum clearfix">
            <span class="fl">购买数量</span>
            <p class="editBtn fr" v-text="currNum"></p>
        </div>
        <!--运费-->
        <div class="freight clearfix">
            <span class="fl">运费</span>
            <span class="fr">包邮</span>
        </div>
        <!--红包-->
        <div class="packet clearfix">
            <span class="fl">红包</span>
            <!--<span class="choPacket fr" v-text="ifusePack[ifusePackState]"></span>-->
            <span class="choPacket fr" v-text="ifusePack"></span>
        </div>
        <!--留言-->
        <div class="userMsg clearfix boxSizing">
            <p class="userMsgfl fl">留言</p>
            <p class="fl userMsgfr" v-text="user_remark"></p>
        </div>
        <!--实付-->
        <div class="fifnalPay">
            <span class="fl">实付款</span>
            <p class="fr">¥<span v-text="finalPay"></span></p>
        </div>
        <!--订单信息-->
        <div class="orderSum">
            <div class="orderCode">订单编号：<span v-text="orderCode"></span></div>
            <div class="buyTime">下单时间：<span v-text="buyTime"></span></div>
            <div class="payTime">付款时间：<span v-text="payTime"></span></div>
            <div class="sendTime">发货时间：<span v-text="sendTime"></span></div>
        </div>
        <div style="height: 80px;"></div>
        <!--删除订单 再次购买-->
        <div class="orderState">
            <p class="fl delOrcan" v-text="statusDel" @click="delOrder"></p>
            <p class="fr buyAgain" v-text="statusBuy" @click="buyAgain"></p>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import qs from "qs";
    import moment from "moment/moment.js";
    import common from "../common";
    import { MessageBox } from "mint-ui";
    export default {
        name: "orderDel",
        data() {
            return {
                bookCover: '' ,
                booktit: '' ,
                bookPrice: '' ,
                currNum: '1',
                addr_id: '',
                goods_id: '',
                user_remark: '',
                addressee: '',
                phone: '',
                address: '',
                orderCode: '',
                create_time: '',
                finalPay: '',
                buyTime: '',
                payTime: '',
                sendTime: '',
                statusDel: '',
                statusBuy: '',
                orderStatus: '',
                buyAgainurl: '',
                dikou: '',
                ifusePackState: '',
                ifusePack: '未使用红包',
                payFrom:''//支付来源，pc,h5,公众号，支付宝等
            }
        },
        created() {
            this.getOrderDel();
            common.iflogin();
        },
        mounted(){
            //支付弹框
            this.showMsgBox();
            //var _this = this;
            // //支付弹框
            // if(localStorage.getItem('ifwxpay')){
            //     setTimeout(function () {
            //         MessageBox.confirm('是否已支付完成？',{
            //             title:"提示",
            //             confirmButtonClass:'confirmButton',
            //             cancelButtonClass:'cancelButton',
            //         })
            //             .then((action) => {
            //                 localStorage.removeItem('ifwxpay');
            //                 //alert('oooooooooooo');
            //                 if (action == 'confirm') {
            //                     //alert('kkkkkkkkkkkkkk');
            //                     //alert(localStorage.getItem('orderId'));
            //                     _this.$router.push({path:'/orderDel',query:{id:localStorage.getItem('orderId')}});
            //                 }
            //             })
            //             ["catch"]((err) => {
            //             if(err == 'cancel'){
            //                 localStorage.removeItem('ifwxpay');
            //                 _this.$router.go(0);
            //             }
            //             return false;
            //         });
            //     },2000);
            // }
        },
        methods: {
            //获取订单详情
            getOrderDel:function () {
                axios
                    .post(
                        "wap/orderHandle/getOrder",
                        qs.stringify({
                            orderId:this.$route.query.id || common.getUrlKey('orderId')
                        })
                    )
                    .then(data => {
                        console.log(data);
                        var data = data.data.data;
                        this.goods_id = data.goods_id;
                        this.addressee = data.addressee;
                        this.phone = data.phone;
                        this.address = data.address;
                        this.bookCover = data.goods_cover;
                        this.booktit = data.goods_name;
                        this.bookPrice = data.goods_price;
                        this.currNum = data.goods_num;
                        this.orderCode = data.id;
                        this.finalPay = data.money;
                        this.payFrom = data.order_agent;
                        //判断是否使用过红包
                        if(data.money == data.goods_price*data.goods_num){
                            //this.ifusePackState = 0;
                            //console.log(data.goods_price*data.goods_num);
                            this.ifusePack = '未使用红包';
                        }else{
                            //this.ifusePackState = 1;
                            //this.ifusePack = '红包已减'+ (data.goods_price*data.goods_num - data.money) +'元';
                            var totPrice = common.floatObj().multiply(data.goods_price,data.goods_num);
                            var fifPrice = common.floatObj().subtract(totPrice,data.money);
                            this.ifusePack = '红包已减'+ (fifPrice) +'元';
                            this.dikou = data.goods_price*data.goods_num - data.money;
                        }
                        this.user_remark = data.user_remark;
                        this.orderStatus = data.status;
                        this.buyAgainurl = data.payment_key;
                        this.statusDel = data.status === 0 ? "取消订单" : "删除订单";
                        this.statusBuy = data.status === 0 ? "立即付款" : "再次购买";
                        this.buyTime = moment(data.create_time).format('YYYY-MM-DD HH:mm:ss');
                        this.payTime = data.payfor_time == null ? "暂无付款时间" : moment(data.payfor_time).format('YYYY-MM-DD HH:mm:ss');
                        this.sendTime = data.cour_time == null ? "暂无发货时间" : moment(data.cour_time).format('YYYY-MM-DD HH:mm:ss');
                        //商品信息存到内存
                        localStorage.setItem('bookCover',data.goods_cover);
                        localStorage.setItem('booktit',data.goods_name);
                        localStorage.setItem('bookPrice',data.goods_price);
                    })
                    ["catch"](error => {
                    console.log(error);
                });
            },
            // 立即购买 或 再次购买
            buyAgain:function () {
                //立即购买
                if (this.orderStatus === 0) {
                    //判断this.payFrom == 4 则调起公众号端——微信内支付
                    if(this.payFrom == 4) {
                        this.$WxJsapiPay('/wap/WxpayFor/JSAPI_ContinuePay',{prepay_id:this.buyAgainurl},(res)=>{
                            this.$router.go(0);
                            return res;
                        },(err)=>{
                            this.Toast({ message: err.msg, position: "center", duration: 2000 });
                        })
                    }else if(this.payFrom == 3){          //h5浏览器端支付
                        //存储ifwxpay,解决谷歌不跳转直接刷新
                        localStorage.setItem('ifwxpay',true);
                        //解决ios浏览器跳到首页重定向
                        localStorage.setItem("IsPayStatuCodeByH5", "1");
                        var path = window.location.href;
                        localStorage.setItem("RedirectPath",path);
                        this.showMsgBox();
                        location.href = this.buyAgainurl;
                    }else{
                        //其他端支付生成的订单全部提示信息
                        this.Toast({
                            message: "请到下单处进行支付！",
                            position: "center",
                            duration: 2000
                        });
                    }

                    //修改前
                    //location.href = this.buyAgainurl;
                    // var _this = this;
                    // setTimeout(function () {
                    //     MessageBox.confirm('是否已支付完成？',{
                    //         title:"提示",
                    //         // cancelButtonText:'未支付',
                    //         confirmButtonClass:'confirmButton',
                    //         cancelButtonClass:'cancelButton',
                    //
                    //     })
                    //         .then(() => {
                    //             //alert(_this.$route.query.id);
                    //             // _this.$router.push({path:'/orderDel',query:{id:_this.$route.query.id}});
                    //             _this.$router.go(0);
                    //         })
                    //         ["catch"](() => {
                    //             return false;
                    //         });
                    // },500)
                }else{
                    //再次购买
                    this.$router.push({ path: "/editOrder",query:{id:this.goods_id}});
                }
            },
           //删除订单
            delOrder: function () {
                var url;
                if( this.orderStatus == 0){
                    url = '/wap/orderHandle/closeOrder';
                }else{
                    url = '/wap/orderHandle/delOrder';
                }
                axios
                    .post(
                        url,
                        qs.stringify({
                            orderId: this.orderCode
                        })
                    )
                    .then(data => {
                        // this.$router.back(-1);
                        this.$router.push('myOrder');

                        this.Toast({
                            message: data.data.msg,
                            position: "center",
                            duration: 2000
                        });
                    })
                    ["catch"](error => {
                    console.log(error);
                });
            },
            showMsgBox:function () {
                //支付弹框
                //var _this = this;
                if(localStorage.getItem('ifwxpay')){
                    //setTimeout(function () {
                        MessageBox.confirm('是否已支付完成？',{
                            title:"提示",
                            confirmButtonClass:'confirmButton',
                            cancelButtonClass:'cancelButton',
                        })
                            .then((action) => {
                                if (action == 'confirm') {
                                    localStorage.removeItem('ifwxpay');
                                    localStorage.removeItem('IsPayStatuCodeByH5');
                                    this.$router.go(0);
                                    //this.$router.push({path:'/orderDel',query:{id:localStorage.getItem('orderId')}});
                                }
                            })
                            ["catch"]((err) => {
                                if(err == 'cancel'){
                                    localStorage.removeItem('ifwxpay');
                                    localStorage.removeItem('IsPayStatuCodeByH5');
                                    this.$router.go(0);
                                }
                                return false;
                            });
                   // },500);
                };
            }
        }
    };
</script>

<style scoped lang="scss">
    .container{
        font-size: 26px;
    }
    .chooseAdr{
        height: 180px;
    }
    .adrbtn{
        width: 10%;
        font-size: 40px;
        text-align: center;
        height: 180px;
        line-height: 180px;
        em{
            font-size: 40px;
        }
    }
    .adrMidd{
        width: 80%;
        div{
            margin: 34px 0 16px;
        }
        .adrdel{color: #666}
    }
    .adrRight{
        width: 10%;
        text-align: center;
        height: 180px;
        line-height: 180px;
    }
    .icon-youjiantou{
        font-size: 40px;
        color: #333;
    }
    .icon-jian,.icon-jia{
        color: #333;
    }
    .lineBg{
        border-bottom: 20px solid #F6F7F8;
    }
    /*商品信息*/
    .shopdelBox{
        padding: 30px;
        border-bottom: 20px solid #F6F7F8;
        .shopimg{
            img{
                width: 200px;
                height: 200px;
                margin-right: 20px;
            }
        }
        .shopName{
            font-size: 28px;
            margin: 30px 0;
        }
        .shopNP{
            line-height: 30px;
        }
        .shopPrice{
            font-size: 32px;
            color: #D63C32;
            font-weight: bold;
        }
        .shopNum{
            color: #999;
            font-size: 24px;
        }
    }
    /*编辑数量*/
    .editNum{
        padding: 0 30px;
        line-height: 86px;
        border-bottom: 1PX solid #E1E1E1;
        .currNum{
            display: inline-block;
            width: 100px;
            height: 54px;
            line-height: 54px;
            margin: 0 20px;
            text-align: center;
            background: #e5e5e5;
        }
    }
    .freight,.packet,.fifnalPay{
        padding: 0 30px;
        line-height: 86px;
        border-bottom: 1PX solid #E1E1E1;
    }
    .choPacket{
        color: #D63C32;
    }
    /*用户留言*/
    .userMsg{
        width: 100%;
        height: auto;
        min-height: 26px;
        padding: 30px;
        border-bottom: 1PX solid #E1E1E1;
        .userMsgfl{
            width: 10%;
            height: 100%;
        }
        .userMsgfr{
            width: 90%;
            word-wrap: break-word;
        }
    }
    .fifnalPay{
        height: 86px;
        border-bottom: 20px solid #F6F7F8;
    }
    .orderSum{
        padding: 24px 0 0 30px;
        font-size: 24px;
        color: #666;
        div{
            margin-bottom: 20px;
        }
    }
    /*删除订单 再次购买*/
    .orderState{
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 98px;
        line-height: 98px;
        background: #efefef;
        font-size: 32px;
        p{
            width: 50%;
            text-align: center;
            color: #fff;
        }
        .buyAgain{
            background: #ff8b11;
        }
        .delOrcan{
            color: #999;
        }
    }
</style>
